/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
import router from '@/router/index';
// getHumanReadableKeys
import {extractErrorDetails } from '@/helpers/util.js';

const initialState = () => ({
  inserting_train: false,
  update_key_taktplan: 0,
  own_projects: {},
  selected_sequence: {
    community: false,
    id: -1,
  },
  // Project Variables
  show_status_badges: true,
  edit_key: localStorage.getItem('TAKT_edit_key') || '',
  //system Variables
  error: '',
  loading: false,
  overview_filter: '',
  permission_action_lookup: {
    'Link': 'CREATE',
    'Add': 'CREATE',
    'Update': 'UPDATE',
    'Delete': 'DELETE',
    'Read': 'READ',
  },
  permission_entity_lookup: {
    'Trains': 'Train',
    'Taktareas': 'TaktArea',
    'Waggons': 'TWaggon',
    'Work Packages': 'TWorkPackage',
    'Work Steps': 'TWorkStep',
    'Quality Steps': 'TQualityStep',
    'Design Steps': 'TDesignStep',
    'Defect Steps': 'TDefectStep',
    'Logistic Steps': 'TLogisticStep',
    'Handover Steps': 'THandoverStep',
    'Machine Steps': 'TMachineStep',
    'Material Steps': 'TMaterialStep',
    'Cost Steps': 'TCostStep',
    'AutopilotIssues': 'AutopilotIssue',
    'Elements': 'Element',
  }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  // Local Project Store variables
  getEditKey: (state) => state.edit_key,
  getOwnProject: (state) => (id) => {
    return state.own_projects[id] || {};
  },
  isEditMode: (state) => !!state.edit_key,
  isLoading: (state) => state.loading,
  getUpdateKeyTaktPlan: (state) => state.update_key_taktplan,
  isInsertingTrain: (state) => state.inserting_train,
  isShowStatusBadges: (state) => state.show_status_badges,
  // Project Getters in UltraStore
  getProjectLength: (state, getters, rootState, rootGetters) => (project_id) => {
    let max_length_train = 0;
    rootState.Ultra.projects[project_id].trains.forEach(train_id => {
      if (rootGetters['Train/getTrainLength'](train_id) > max_length_train) {
        max_length_train = rootGetters['Train/getTrainLength'](train_id);
      }
    });
    rootState.Ultra.projects[project_id].wbgroups.forEach(wbgroup_id => {
      let wbgroup = rootState.Ultra.wbgroups[wbgroup_id];
      wbgroup.wblines.forEach(wbline_id => {
        let wbline = rootState.Ultra.wblines[wbline_id];
        wbline.wbworkpackages.forEach(wbworkpackage_id => {
          let wbworkpackage = rootState.Ultra.wbworkpackages[wbworkpackage_id];
          if (wbworkpackage.position !== -1) {
            let wbworkpackage_end = wbworkpackage.position + wbworkpackage.length-1;
            if (wbworkpackage_end > max_length_train) {
              max_length_train = wbworkpackage_end;
            }
          }
        });
      });
    });
    return max_length_train;
  },
  getProjectInvoice: (state, getters, rootState) => (payload) => {
    const index = rootState.Ultra.projects[payload.project_id].invoices.findIndex(function(item) {
      return item.id == payload.invoice_id;
    });
    return rootState.Ultra.projects[payload.project_id].invoices[index];
  },
  getStatusArray: (state, getters, rootState) => {
    let array = [];
    for (var i = 1; i < rootState.Ultra.status_array.length; i++) {
      array.push(rootState.Ultra.status_array[i]);
    }
    return array;
  },
  getStatisticsTrainSelector: (state, getters, rootState) => (project_id) => {
    let train_selector = [];
    for (let id in rootState.Ultra.projects[project_id].trains) {
      train_selector.push({
        value: rootState.Ultra.projects[project_id].trains[id],
        icon: 'train',
        ticon: 'takt-plan-train',
        tooltip: rootState.Ultra.trains[rootState.Ultra.projects[project_id].trains[id]].name
      });
    }
    return train_selector;
  },
  getStatisticsMilestoneSelector: (state, getters, rootState) => (project_id) => {
    let milestone_selector = [];
    for (let id in rootState.Ultra.projects[project_id].milestones) {
      milestone_selector.push({
        value: rootState.Ultra.projects[project_id].milestones[id],
        icon: 'flag',
        ticon: 'rhombus',
        tooltip: rootState.Ultra.milestones[rootState.Ultra.projects[project_id].milestones[id]].name
      });
    }
    return milestone_selector;
  },
  hasProjectPermission: (state, getters, rootState) => (payload) => {
    // let permission_entity = state.permission_entity_lookup[payload.entity];
    // let permission_action = state.permission_action_lookup[payload.action];
    // if ( !rootState.Auth.permissions.includes(`${permission_entity} ${permission_action}`) ) {
    //   return false;
    // }
    if (rootState.Ultra.projects[payload.project_id]) {
      return rootState.Ultra.projects[payload.project_id].ppermissions.includes(payload.ppermission);
    }
    return false;
  },
  hasProjectPermissionForTWP: (state, getters, rootState) => (payload) => {
    let permission_entity = state.permission_entity_lookup[payload.entity];
    let permission_action = state.permission_action_lookup[payload.action];
    if ( !rootState.Auth.permissions.includes(`${permission_entity} ${permission_action}`) ) {
      return false;
    }
    if (payload.action !== 'Read') {
      if (payload.action === 'Update') {
        if (
            rootState.Ultra.projects[payload.project_id].ppermissions.includes('Update Work Packages') ||
            (
              rootState.Ultra.projects[payload.project_id].ppermissions.includes('Update Own Work Packages') &&
              rootState.Ultra.projects[payload.project_id].own_twork_packages.includes(payload.twp)
            )
          ) {
          return true;
        } else {
          return false;
        }
      } else {
        return rootState.Ultra.projects[payload.project_id].ppermissions.includes(payload.action + ' ' + payload.entity);
      }
    }
    return rootState.Ultra.projects[payload.project_id].ppermissions.includes(payload.action + ' ' + payload.entity);
  },
  getProjectTooltip: (state, getters, rootState) => (payload) => {
    let permission_entity = state.permission_entity_lookup[payload.entity];
    let permission_action = state.permission_action_lookup[payload.action];
    if ( !rootState.Auth.permissions.includes(`${permission_entity} ${permission_action}`) ) {
      return `${payload.entity} are part of the TAKT.ing PRO.account.`;
    }
    if (payload.action !== 'Read') {
      if ( 
          rootState.Ultra.projects[payload.project_id].ppermissions.includes('Update Work Packages') || 
          (
            rootState.Ultra.projects[payload.project_id].ppermissions.includes('Update Own Work Packages') &&
            rootState.Ultra.projects[payload.project_id].own_twork_packages.includes(payload.twp)
          )
        ) {
        if (rootState.Ultra.projects[payload.project_id].ppermissions.includes(payload.action + ' ' + payload.entity)) {
          return `${payload.action} ${payload.entity}`;
        } else {
          return `Your PROJECT.role is not allowed to use ${payload.entity}.`;
        }
      } else {
        return `Your PROJECT.role is not allowed to use ${payload.entity}.`;
      }
    }
    if (rootState.Ultra.projects[payload.project_id].ppermissions.includes(payload.action + ' ' + payload.entity)){
      return `${payload.entity}`;
    }
    return `Your PROJECT.role is not allowed to use ${payload.entity}.`;
  },
  //Project Getters in UltraStore: deprecated -> use mapState in component
  getOwnTWorkPackages: (state, getters, rootState) => (project_id) => {
    return rootState.Ultra.projects[project_id].own_twork_packages;
  },
  getProject: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id] || {};
  },
  getProjectStats: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].stats;
  },
  getProjectInvitations: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].invitations;
  },
  getProjectClients: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].clients;
  },
  getProjectStatus: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].status;
  },
  getProjectAddress: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].address;
  },
  getProjectInvoiceAddress: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].invoice_address;
  },
  getProjectInvoices: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].invoices;
  },
  getProjectOwnerInvoices: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].owner_invoices;
  },
  getProjectProles: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].proles;
  },
  getProjectStart: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].calendar_project_start;
  },
  getProjectName: (state, getters, rootState) => (id) => {
    return rootState.Ultra.projects[id].name;
  },
  getProjectOverview: (state, getters, rootState, rootGetters) => (project_show_toggle) => {
    let projects = [];
    if (project_show_toggle === 'all' || project_show_toggle === 'multi') {
      Object.keys(rootState.Ultra.multiprojects).forEach((multi_project_id) => {
        projects.push(rootState.Ultra.multiprojects[multi_project_id]);
      });
    }
    if (project_show_toggle === 'all' || project_show_toggle === 'projects') {
      rootGetters['Ultra/getUObjects']({type:'projects', ids: rootState.Auth.current_user.projects}).forEach((project) => {
        if (typeof project !== 'undefined' && 
        (project.status !== 'terminated' || 
         localStorage.getItem('Project_Overview_Show_Terminated') === 'true')
       ) {
      projects.push(project);
    }
      });
    }

    if (localStorage.getItem('Project_Overview_Show_Company_Only') === 'true') {
      projects = projects.filter( p => {
        return (
          p.type === 'projects' && rootState.Auth.current_user.business.projects.includes(p.id) ||
          p.type === 'multiprojects' && p.projects.some(val => rootState.Auth.current_user.business.projects.includes(val))
          );
      });
    }

    if (state.overview_filter === '') {
      return projects;
    } else {
      return projects.filter( p => {
        return p.name.toLowerCase().includes(state.overview_filter.toLowerCase())
      });
    }
  },
  getOwnProjectOverview: (state) => state.own_projects,
  getSelectedSequence: (state) => state.selected_sequence,
  getFullStatusArray: (state, getters, rootState) => {
    return rootState.Ultra.status_array;
  },
  getMultiProjectInformation: (state, getters, rootState) => (multi_project_id) => {
    // for each information sum all values of the projects
    let project_information = {
      free_days_count: 0,
      milestones_count: 0,
      relations_count: 0,
      taktareas_count: 0,
      tenders_count: 0,
      trains_count: 0,
      user_count: 0,
      waggons_count: 0,
      work_packages_count: 0,
      work_steps_count: 0,
      site_count: 0,
      element_count: 0,
    };
    rootState.Ultra.multiprojects[multi_project_id].projects.forEach((project_id) => {
      Object.keys(project_information).forEach((key) => {
        project_information[key] += rootState.Ultra.projects[project_id].information[key];
      });
    });
    project_information.user_count = rootState.Ultra.multiprojects[multi_project_id].user_count;
    return project_information;
  },
  getMultiProjectSubProjects: (state, getters, rootState) => (multi_project_id) => {
    let sub_projects = [];
    let count = getters.getMultiProjectSubProjectsCount(multi_project_id);
    for (var i = 0; i < count.project_count; i++) {
      sub_projects.push(rootState.Ultra.projects[rootState.Ultra.multiprojects[multi_project_id].projects[i]]);
    }
    return sub_projects;
  },
  getMultiProjectSubProjectsCount: (state, getters, rootState) => (multi_project_id) => {
    let count = rootState.Ultra.multiprojects[multi_project_id].projects.length;
    if (count < 5){
      return {
        project_count: count,
        additional_count: 0
      };
    } else {
      return {
        project_count: 3,
        additional_count: count - 3
      };
    }
  },
  getProjectTaktareas: (state, getters, rootState) => (project_id) => {
    let taktarea_ids = []
    let train_ids = rootState.Ultra.projects[project_id].trains;
    train_ids.forEach(train_id => {
      taktarea_ids = taktarea_ids.concat(rootState.Ultra.trains[train_id].taktareas);
    })
    return taktarea_ids;
  }
};
// Actions
const actions = {
  /*eslint no-empty-pattern: "off"*/
  downloadTWorkpackageImages({}, payload) {
    axios({
      url: 'projects/' + payload.project_id + '/downloadTWorkpackageImages',
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${payload.project_name}.zip`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  exportCSV({commit}, payload) {
    axios({
      url: 'projects/' + payload.project_id + '/exportcsv',
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${payload.project_name}.zip`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err) => {
        commit('View/set_user_feedback', err, { root: true });
      });
  },
  exportLogListCSV({}, payload) { 
    axios({
      url: 'projects/' + payload.project_id + '/exportloglistcsv',
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `project_loglist.zip`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  exportCSVHistory({}, payload) {
    axios({
      url: `projects/${payload.project_id}/histprojects/${payload.histproject_id}/exportcsv`,
      method: 'GET',
      responseType: 'blob',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${payload.project_name}.zip`);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error);
      });
  },
  // with Ultra store mutation
  requestProjectInformation({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/information',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              information: resp.data.data
            }
          };
          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  requestOwnTWorkPackages({commit, rootState}, payload) {
    axios({
        url: 'projects/' + payload.project_id + '/owntworkpackages',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
    .then(resp => {
      let ultra_payload = {
        url: [
          {projects: payload.project_id}
        ],
        update: {
          work_packages: resp.data.data
        }
      };

      commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
    });
  },
  testSocket({commit}, payload) {
    axios({
        url: 'projects/' + payload.project_id + '/socket',
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
    .then(() => {
    }).catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  requestProjectAddress({commit, rootState}, payload){
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/address',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              address: resp.data.data.address,
              invoice_address: resp.data.data.invoice_address
            }
          };

          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  requestProjectInvoices({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/invoices',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              invoices: resp.data.data
            }
          };

          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  requestProjectInvoicesByOwner({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/invoices?owner=true',
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              owner_invoices: resp.data.data
            }
          };

          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  requestProjectInvites({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/invites?show=showForUserInvites',
          method: 'GET',
          headers: {
            'cache-control': 'no-cache'
          }
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              invitations: resp.data.data
            }
          };

          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  requestProjectPermissions({commit, rootState, rootGetters}, payload) {
    return new Promise((resolve, reject) => {
      if (rootGetters['Auth/getUserId'] === 0) {
        // setTimeout(function () {
          axios({
            url: 'users/' + rootGetters['Auth/getUserId'] + '/ppermissions/' + payload.project_id,
            method: 'GET',
            headers: {
              'cache-control': 'no-cache'
            }
          })
          .then(resp => {
            let ultra_payload = {
              url: [
                {projects: payload.project_id}
              ],
              update: {
                ppermissions: resp.data.data
              }
            };

            commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
            resolve();
          })
          .catch(err => {
            commit('set_error', extractErrorDetails(err));
            commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
            reject();
          });
        // }, 1500);
      } else {
        axios({
          url: 'users/' + rootGetters['Auth/getUserId'] + '/ppermissions/' + payload.project_id,
          method: 'GET',
          headers: {
            'cache-control': 'no-cache'
          }
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
            ppermissions: resp.data.data
            }
          };

          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
      }
    });
  },
  requestProjectClients({commit, rootState}, payload) {
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/clients?show=showWithEntities',
          method: 'GET',
          headers: {
            'cache-control': 'no-cache'
          },
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              clients: resp.data.data
            }
          };

          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  uploadProjectImage( {commit, rootState}, payload) {
    axios({
      url: 'projects/' + payload.project_id + '/imageupload',
      method: 'POST',
      data: payload.image,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    .then(resp => {
      let ultra_payload = {
        url: [
          {projects: payload.project_id}
        ],
        update: {
          image: resp.data.data.image
        }
      };

      commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  updateProjectStatus({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/updatestatus',
      method: 'PUT',
      data: payload.payload
    })
    .then(() => {
      let ultra_payload = {
        url: [
          {projects: payload.project_id}
        ],
        update: {
          status: payload.payload.status
        }
      };
      commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },
  requestProjectStats({commit, rootState}, project_id) {
    return new Promise((resolve, reject) => {
      let promises = [
        axios({
          url: 'projects/' + project_id +'/stats',
          method: 'GET'
        }),
        axios({
          url: 'projects/' + project_id +'/reportprojectadherence',
          method: 'GET'
        }),
        axios({
          url: 'projects/' + project_id +'/reportstatusprogress',
          method: 'GET'
        }),
        axios({
          url: 'projects/' + project_id +'/reporttradestatus',
          method: 'GET'
        })
      ];
      Promise.all(promises).then(res => {
        commit('set_project_status_progress_report', {rootState: rootState, payload: {project_id: project_id, res: res[2].data.data}});
        commit('set_project_trade_status_report', {rootState: rootState, payload: {project_id: project_id, data: res[3].data.data}});
        commit('set_project_adherence_report', {rootState: rootState, payload: {project_id: project_id, data: res[1].data.data}});
        commit('set_project_stats', {rootState, payload: res[0].data.data});

        resolve();
      }).catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  deleteProject({commit}, payload) {
    let project_id = payload;
    axios({
        url: 'projects/' + project_id,
        method: 'DELETE'
      })
      // resp
      .then(() => {
        let ultra_payload = {
          url: [
            {projects: project_id}
          ]
        };
        commit('Auth/leave_project', project_id, {root: true});
        commit('Ultra/delete_u_object', ultra_payload, {root: true});
        router.push({
          name: 'ProjectOverView',
          params: {
            project_id: project_id,
            train_index: 0,
            direction: 0
          }
        });
      }).catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
    });
  },

  //with local mutation mutating Ultra Store
  requestUpdateProjectInvoice({commit, rootState}, payload){
    return new Promise((resolve, reject) => {
      axios({
          url: 'projects/' + payload.project_id + '/invoices/' + payload.invoice_id,
          method: 'PUT',
          data: { status: payload.status }
        })
        .then(() => {
          commit('project_update_invoice', {rootState, payload: {
            project_id: payload.project_id,
            invoice_id: payload.invoice_id,
            status: payload.status
          }});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
    });
  },
  //Local Project variables
  setShowStatusBadges({commit}, boolean) {
    commit('set_show_status_badges', boolean);
  },
  enterEditMode({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (state.edit_key === '') {
        axios({
          url: 'projects/' + payload.project_id + '/activatededitmode',
          method: 'PUT',
        })
        .then(resp => {
          const edit_key = resp.data.data.edit_key;
          localStorage.setItem('TAKT_edit_key', edit_key);
          commit('enter_edit_mode', edit_key);
          commit('Ultra/reset_action_stack', null, {root: true});
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
          reject();
        });
      } else {
        resolve();
      }
    });
  },
  leaveEditMode({ commit }, payload) {
    if (state.edit_key !== '') {
      axios({
        url: 'projects/' + payload.project_id + '/deactivatededitmode',
        method: 'PUT',
        data: {edit_key: state.edit_key}
      })
      .then(() => {
        localStorage.setItem('TAKT_edit_key', '');
        commit('leave_edit_mode');
        commit('Ultra/reset_action_stack', null, {root: true});
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
    }
  },
  resetEditMode({ commit }, payload) {
      axios({
        url: 'projects/' + payload.project_id + '/reseteditmode',
        method: 'PUT'
      })
      .then(() => {
        localStorage.setItem('TAKT_edit_key', '');
        commit('leave_edit_mode');
        commit('Ultra/reset_action_stack', null, {root: true});
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
      });
  },
  setSelectedSequence({commit}, payload) {
    commit('set_selected_sequence', payload);
  },
  updateProjectAddress({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/address',
      method: 'PUT',
      data: rootState.Ultra.projects[payload.project_id].address
    })
    .then(() => {
      commit('View/set_project_data_editing', '', { root: true });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateProjectInvoiceAddress({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/invoiceaddress',
      method: 'PUT',
      data: rootState.Ultra.projects[payload.project_id].invoice_address
    })
    .then(() => {
      commit('View/set_project_data_editing', '', { root: true });
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  setInsertingTrain({commit}, boolean) {
    commit('set_inserting_train', boolean);
  },
  requestOwnerProjects({commit}, client_id) {
    return new Promise((resolve, reject) => {
      let url_query = '';
      if (client_id) {
        url_query = '&client_id=' + client_id;
      }
      axios({
          url: 'projects?own=true' + url_query,
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache'
          }
        })
        .then(resp => {
          commit('own_project_overview_success', resp.data.data);
          resolve();
        })
        .catch(err => {
          commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },

  //Clients
  createAndAddClientToProject({commit, getters, rootState}, payload){
    axios({
      url: 'clients',
      method: 'POST',
      data: payload.client
    })
    .then( resp => {

      let proles = getters.getProjectProles(payload.project_id);
      let prole;
      for (let i = 0; i < proles.length; i++) {
        if (proles[i].name === 'Owner') {
          prole = proles[i];
          break;
        }
      }
      axios({
        url: 'projects/' + payload.project_id + '/addclients',
        method: 'PUT',
        data: {
          clients: [{
            id: resp.data.data.id,
            prole: prole.id
          }]
        }
      })
      .then( () => {
        let client = resp.data.data;
        client.callbacks = [];
        commit('add_client_to_project', {rootState, payload: {
          project_id: payload.project_id,
          client: client
        }});
      })
      .catch(add_err => {
        commit('set_error', extractErrorDetails(add_err));
      });

    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  createCallback({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/callbacks',
      method: 'POST',
      data: payload.callback
    })
    .then(resp => {
      commit('add_callback', {rootState, payload: {
        project_id: payload.project_id,
        client_id: payload.callback.client,
        callback: resp.data.data
      }});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteClient({commit, rootState}, payload){
    axios({
      url: 'clients/' + payload.client_id,
      method: 'DELETE'
    })
    .then( () => {
      commit('remove_client', {rootState, payload});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteCallback({commit, rootState}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/callbacks/' + payload.callback_id,
      method: 'DELETE'
    })
    .then( () => {
      commit('remove_callback', {rootState, payload});
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  resolveTag({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/0/tags/0' + payload.query,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        router.push({path: resp.data.data.uri});
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject(err.response.data.error_msg);
      });
    });
  },
  projectLoading({commit}, isLoading){
      commit('project_loading', isLoading);
  },
  updateOverviewFilter({commit}, search){
    commit('update_overview_filter', search);
  },
  copyTaktareaToSequence({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/trains/${payload.train_id}/taktareas/${payload.taktarea_id}/tosequence`,
        method: 'POST',
        data: { 
          name: payload.name,
          copy_workpackages: payload.copy_workpackages,
          hashtags: payload.hashtags
        }
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  copyTaktareaToBSequence({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/trains/${payload.train_id}/taktareas/${payload.taktarea_id}/tobsequence`,
        method: 'POST',
        data: { 
          name: payload.name,
          copy_workpackages: payload.copy_workpackages,
          hashtags: payload.hashtags
        }
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        reject();
      });
    });
  },
  addUnstagedElementId({commit, rootState}, payload){
    commit('add_unstaged_element_id', {rootState, payload});
  },
  removeUnstagedElementId({commit, rootState}, payload){
    commit('remove_unstaged_element_id', {rootState, payload});
  },

  requestMicroLevel({commit, rootState}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/microlevel?index=${payload.takt_index}`,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
      .then(resp => {
        commit('Ultra/create_u_objects', {rootState: rootState, payload: {resp_data: resp.data.data}}, {root: true});
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject(err.response.data.error_msg);
      });
    });
  },
};
// Mutations
const mutations = {
  //local state mutation
  enter_edit_mode(state, edit_key) {
    state.edit_key = edit_key;
  },
  leave_edit_mode(state) {
    state.edit_key = '';
  },
  project_loading(state, loading) {
    state.loading = loading;
  },
  set_selected_sequence(state, payload) {
    state.selected_sequence = {
      community: payload.community,
      id: payload.id,
    };
  },
  set_inserting_train(state, boolean) {
    state.inserting_train = boolean;
  },
  set_update_key_taktplan(state) {
    state.update_key_taktplan++;
  },
  set_show_status_badges(state, boolean) {
    state.show_status_badges = boolean;
  },
  own_project_overview_success(state, own_projects) {
    state.own_projects = {};
    for (let i = 0; i < own_projects.length; i++) {
      if (state.own_projects[own_projects[i].id]) {
        Vue.set(state.own_projects, own_projects[i].id, Object.assign({}, state.own_projects[own_projects[i].id], own_projects[i]));
      } else {
        Vue.set(state.own_projects, own_projects[i].id, own_projects[i]);
      }
    }
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err) {
    state.error = err;
  },

  //ultra store state mutation
  project_update_invoice(state, {rootState, payload}){
    const index = rootState.Ultra.projects[payload.project_id].invoices.findIndex(function(item) {
      return item.id == payload.invoice_id;
    });
    Vue.set(rootState.Ultra.projects[payload.project_id].invoices[index], 'status', payload.status);
  },
  project_add_owner_invoice(state, {rootState, payload}){
    rootState.Ultra.projects[payload.project_id].owner_invoices.push(payload.invoice);
  },
  add_client_to_project(state, {rootState, payload}){
    let clients = [];
    if (rootState.Ultra.projects[payload.project_id].clients) {
      clients = [...rootState.Ultra.projects[payload.project_id].clients];
    }
    clients.push(payload.client);
    Vue.set(rootState.Ultra.projects[payload.project_id], 'clients', clients);
  },

  add_callback(state, {rootState, payload}){
    let callbacks = [];
    for (var i = 0; i < rootState.Ultra.projects[payload.project_id].clients.length; i++) {
      if (rootState.Ultra.projects[payload.project_id].clients[i].id === payload.client_id) {
        callbacks = [...rootState.Ultra.projects[payload.project_id].clients[i].callbacks];
        break;
      }
    }
    callbacks.push(payload.callback);
    Vue.set(rootState.Ultra.projects[payload.project_id].clients[i], 'callbacks', callbacks);
  },
  remove_callback(state, {rootState, payload}){
    let client_index = rootState.Ultra.projects[payload.id].clients.findIndex(client => client.id === payload.client_id);
    let callback_index = rootState.Ultra.projects[payload.id].clients[client_index].callbacks.findIndex(callback => callback.id === payload.callback_id);
    Vue.set(rootState.Ultra.projects[payload.id].clients[client_index], 'callbacks', [
      ...rootState.Ultra.projects[payload.id].clients[client_index].callbacks.slice(0, callback_index),
      ...rootState.Ultra.projects[payload.id].clients[client_index].callbacks.slice(callback_index + 1)
    ]);
  },
  remove_client(state, {rootState, payload}){
    let client_index = rootState.Ultra.projects[payload.id].clients.findIndex(client => client.id === payload.client_id);
    Vue.set(rootState.Ultra.projects[payload.id], 'clients', [
      ...rootState.Ultra.projects[payload.id].clients.slice(0, client_index),
      ...rootState.Ultra.projects[payload.id].clients.slice(client_index + 1)
    ]);
  },

  train_change_position(state, {rootState, payload}) {
    let trains = rootState.Ultra.projects[payload.project_id].trains;
    trains.splice(payload.drag_evt.newIndex, 0, trains.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  train_delete(state, {rootState, payload, train_id}) {
    rootState.Ultra.projects[payload.project_id].trains.splice(payload.train_index, 1);
    Vue.delete(rootState.Ultra.trains, train_id);
  },
  trains_insert_bulk(state, {rootState, payload}) {
    for(let train_id in payload.trains) {
      rootState.Ultra.projects[payload.project_id].trains.splice(payload.trains[train_id].position-1, 0, parseInt(train_id));
    }
  },
  update_twork_step_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].work_cards.find(card => card.id === payload.id), 'done', payload.done);
  },
  update_tquality_step_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].quality_cards.find(card => card.id === payload.id), 'done', payload.done);
  },
  update_tdefect_step_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].defect_cards.find(card => card.id === payload.id), 'done', payload.done);
  },
  update_thandover_step_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].handover_cards.find(card => card.id === payload.id), 'done', payload.done);
  },
  update_tlogistic_step_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].logistic_cards.find(card => card.id === payload.id), 'done', payload.done);
  },
  update_tdesign_step_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].design_cards.find(card => card.id === payload.id), 'done', payload.done);
  },
  step_card_log_list_add_comment(state, {rootState, payload}) {
    var step_cards = rootState.Ultra.projects[payload.project_id].step_cards;
    for (let takt_time in step_cards) {
      for (let card_type in step_cards[takt_time]) {
        for (let i = 0; i < step_cards[takt_time][card_type].length; i++) {
          if (step_cards[takt_time][card_type][i].work_package_id === payload.twork_package_id) {
            step_cards[takt_time][card_type][i].comments.push(payload.comment);
          }
        }
      }
    }
  },
  step_card_log_list_add_image(state, {rootState, payload}) {
    var step_cards = rootState.Ultra.projects[payload.project_id].step_cards;
    for (let takt_time in step_cards) {
      for (let card_type in step_cards[takt_time]) {
        for (let i = 0; i < step_cards[takt_time][card_type].length; i++) {
          if (step_cards[takt_time][card_type][i].work_package_id === payload.twork_package_id) {
            step_cards[takt_time][card_type][i].images.push(payload.image);
          }
        }
      }
    }
  },


  project_overview_success(state, {rootState, projects}) {
    for (let i = 0; i < projects.length; i++) {
      if (rootState.Ultra.projects[projects[i].id]) {
        Vue.set(rootState.Ultra.projects, projects[i].id, Object.assign({}, rootState.Ultra.projects[projects[i].id], projects[i]));
      } else {
        Vue.set(rootState.Ultra.projects, projects[i].id, projects[i]);
      }
    }
  },
  project_delete(state, {rootState, project_id}) {
    Vue.delete(rootState.Ultra.projects, project_id);
  },
  set_project_status_progress_report(state, {rootState, payload}){
    let colors = [
      '#b71c1c', '#1b5e20',
      '#d32f2f', '#388e3c',
      '#ef5350', '#66bb6a',
      '#e57373', '#81c784',
      '#ef9a9a', '#a5d6a7'
    ];
    let labels = [];
    let datasets = [];
    let a = 0;
    for (let i = 0; i < payload.res.ready.length; i++) {
      labels.push(payload.res.ready[i].date);
    }
    for(let key of Object.keys(payload.res)){
      let dataset_actual = {
        borderColor: colors[a],
        label: key.replace(/_/g, ' ').toUpperCase() + '.actual',
        data: []
      };
      a++;
      let dataset_target = {
        borderColor: colors[a],
        label: key.replace(/_/g, ' ').toUpperCase() + '.target',
        data: []
      };
      a++;
      for (let j = 0; j < payload.res[key].length; j++) {
        dataset_actual.data.push(Math.round(payload.res[key][j].actual_value * 100 * 100) / 100);
        dataset_target.data.push(Math.round(payload.res[key][j].target_value * 100 * 100) / 100);
      }
      datasets.push(dataset_actual);
      datasets.push(dataset_target);
    }
    rootState.Ultra.projects[payload.project_id].reportstatusprogress = {
      labels: labels,
      datasets: datasets
    };
  },
  set_project_trade_status_report(state, {rootState, payload}){
    let labels = [];
    let datasets = [];
    let dataset_actual = {
      label: 'Actual',
      barPercentage: 0.5,
      barThickness: 6,
      backgroundColor: '#20B2AA',
      stack: 'Stack 0',
      data: []

    };
    let dataset_deviation = {
      label: 'Deviation',
      barPercentage: 0.5,
      barThickness: 6,
      backgroundColor: '#CD5C5C',
      stack: 'Stack 0',
      data: []
    };
    for (let i = 0; i < payload.data.length; i++) {
      labels.push(payload.data[i].token);
      dataset_actual.data.push(Math.round(payload.data[i].actual_value * 100 * 100) / 100);
      dataset_deviation.data.push(Math.round(payload.data[i].deviation_value * 100 * 100) / 100);
    }
    datasets.push(dataset_actual);
    datasets.push(dataset_deviation);
    rootState.Ultra.projects[payload.project_id].reporttradestatus = {
      labels: labels,
      datasets: datasets
    };
  },
  set_project_adherence_report(state, {rootState, payload}){
    let colors = [
      '#b71c1c'
    ];
    let labels = [];
    let datasets = [];
    let a = 0;
    let dataset = {
      borderColor: colors[a],
      label: 'PROJECT.adherence',
      data: []
    };
    for (let i = 0; i < payload.data.length; i++) {
      labels.push(payload.data[i].date);
      dataset.data.push(Math.round(payload.data[i].adherence * 100) / 100);
    }
    datasets.push(dataset);
    rootState.Ultra.projects[payload.project_id].reportadherence = {
      labels: labels,
      datasets: datasets
    };
  },
  set_project_stats(state, {rootState, payload}){
    for (var train_id in payload.trains) {
      Object.assign(rootState.Ultra.trains[train_id], payload.trains[train_id]);
    }
    for (var project_id in payload.projects) {
      Object.assign(rootState.Ultra.projects[project_id], payload.projects[project_id]);
    }
  },
  update_overview_filter(state, search){
    state.overview_filter = search;
  },
  add_unstaged_element_id(state, {rootState, payload}) {
    if (!rootState.Ultra.projects[payload.project_id].unstaged_elements.includes(payload.element_id)) {
      rootState.Ultra.projects[payload.project_id].unstaged_elements.push(payload.element_id);
    }
  },
  remove_unstaged_element_id(state, {rootState, payload}) {
    let index = rootState.Ultra.projects[payload.project_id].unstaged_elements.findIndex(payload.element_id);
    rootState.Ultra.projects[payload.project_id].unstaged_elements.splice(index, 1);
  },

  // Project entity actions deprecated
  // project_success(state, {rootState, project}) {
  //   if (rootState.Ultra.projects[project.id]) {
  //     Vue.set(rootState.Ultra.projects, project.id, Object.assign({}, rootState.Ultra.projects[project.id], project));
  //   } else {
  //     Vue.set(rootState.Ultra.projects, project.id, project);
  //   }
  // },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
